const CONTROL_CHARACTER_RANGES = '\\u0000-\\u001F\\u007F-\\u009F';

export const SAFE_INTERNAL_PATH_PATTERN = new RegExp(
    `^/(?!/)[^\\\\\\s${CONTROL_CHARACTER_RANGES}]*$`,
    'u',
);

export const isSafeInternalPath = (path: string): boolean =>
    SAFE_INTERNAL_PATH_PATTERN.test(path);
